var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jy-main-litems",attrs:{"flex":"","between":""}},[_c('mainLitemsL',{attrs:{"options":_vm.options}}),_c('userVip',{attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }